// extracted by mini-css-extract-plugin
export var wrapper = "AspectRatio-module--wrapper--SoeWm";
export var content = "AspectRatio-module--content--F0kw1";